.siteContainer.content-loading.text-info-label-bold.disable-select{position:absolute;width:100%;display:flex;align-items:center;justify-content:center;z-index:999;padding-bottom:10%}
/*# sourceMappingURL=layout.component-VHON2Y6S.css.map */
